import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../core/services/common.service';
import { BmpDashboardConfig } from '../../models/dashboard.model';
import { AuthService } from '../../core/services/auth.service';
import { LoaderService } from '../../core/services/loader.service';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.css'],
    standalone: false
})
export class LandingPageComponent implements OnInit {
  items: BmpDashboardConfig[] = [];
  moduleName = 'Benchmarking Plus';
  email?: string;

  constructor(
    private router: Router,
    private dataService: CommonService,
    private userService: AuthService,
    private loaderService: LoaderService
  ) {
    this.dataService.moduleName?.next(this.moduleName);
  }

  ngOnInit(): void {
    this.loaderService.showLoader();
    this.dataService.getReportDetails().subscribe((data) => {
      this.items = data;
      this.dataService.$BmpDashboardConfig.set(data);
      this.loaderService.hideLoader();
    });
  }

  navigateToHome(item: BmpDashboardConfig) {
    let routeName;
    switch (item.dashboardConfigId) {
      // case 1:
      //   routeName = 'apqc';
      //   break;
      // case 2:
      //   routeName = 'ibis';
      //   break;
      // case 3:
      //   routeName = 'bmplus';
      //   if (item.redirectURL) {
      //     window.open(item.redirectURL, '_blank');
      //   }
      //   return;
      // case 5:
      //   routeName = 'apqcadmin';
      //   break;
      // case 6:
      //   routeName = 'fmanalysis';
      //   break;
      // case 13:
      //   routeName = 'fmanalysis-demo';
      //   if (item.redirectURL) {
      //     window.open(item.redirectURL, '_blank');
      //   }
      //   return;
      default:
        if (item.redirectURL) {
          window.open(item.redirectURL, '_blank');
          return;
        } else {
          routeName = 'report';
        }
    }

    if (routeName) {
      this.router.navigate([routeName], {
        queryParams: { reportId: item.dashboardConfigId }
      });
    }
  }
}
